/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: EmbeddedTechnologies
 * Page name:
 * Page Description:
*/

import React from 'react'
import { Row, Col, Image  } from 'react-bootstrap';
import Carousel from "react-multi-carousel";

import Rpi from "assets/images/TechLogo/PNG/Rpi.png"
import Arduino from "assets/images/TechLogo/PNG/Arduino.png"
import Kicad from "assets/images/TechLogo/PNG/Kicad.png"
import Keil from "assets/images/TechLogo/PNG/Keil.png"
import Atmel from "assets/images/TechLogo/PNG/Atmel.png"
import Avr from "assets/images/TechLogo/PNG/Avr.png"
import NodeMCU from "assets/images/TechLogo/PNG/NodeMCU.png"
import Espre from "assets/images/TechLogo/PNG/Espre.png"

const responsive = {
  superLargeDesktop: {

    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

function EmbeddedTechnologies() {


  return (
  <div>
    <div className='embedded_listdisplay1'>
    <Carousel
    className='carouselBorder'
    autoPlay={true}
    responsive={responsive}
    infinite={true}
    autoPlaySpeed={2500}>


    <Row>

    <Col className='center'>
    <Image img src={Rpi} alt="Raspberry pi" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Arduino} alt="Arduino" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Kicad} alt="KiCAD" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Keil} alt="Keil" className='embedded_techimg' />
    </Col>

    </Row>

    <Row>

    <Col className='center'>
    <Image img src={Atmel} alt="Atmel Microcontrollers" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Avr} alt="AVR" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={NodeMCU} alt="NodeMCU" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Espre} alt="ESP" className='embedded_techimg' />
    </Col>

    </Row>


    </Carousel>
    </div>

    <div className='embedded_listdisplay2'>
      <Carousel responsive={responsive}>

        <Carousel.Item interval={5000} className='center'>
          <Image img src={'https://drive.google.com/uc?export=view&id=1_4M6ObOiVyjJ_o1bEKg-AQWKM9f0VfzP'} alt="Raspberry pi" className='embedded_techimg' />
          <Image img src={'https://drive.google.com/uc?export=view&id=1Da_tn7jlRtDjXZRAiyu9603MUHS6cBev'} alt="Arduino" className='embedded_techimg' />
          <Image img src={'https://drive.google.com/uc?export=view&id=1fSUzimWydrvZJS34PL26Ka8OTFzl1KHW'} alt="KiCAD" className='embedded_techimg' />
          <Image img src={'https://drive.google.com/uc?export=view&id=1G2OgyhhO5X7AyzU7muaGXRP5IYl0XvDn'} alt="Keil" className='embedded_techimg' />
        </Carousel.Item>

        <Carousel.Item interval={5000} className='center'>
          <Image img src={'https://drive.google.com/uc?export=view&id=19PFc52WmMq8diwnzEuBo_A-4kPTF55om'} alt="Atmel Microcontrollers" className='embedded_techimg' />
          <Image img src={'https://drive.google.com/uc?export=view&id=1p2bOwzbUIJAdOyuNGNLSc7hzxH_rbI3-'} alt="AVR" className='embedded_techimg' />
          <Image img src={'https://drive.google.com/uc?export=view&id=1fSUzimWydrvZJS34PL26Ka8OTFzl1KHW'} alt="NodeMCU" className='embedded_techimg' />
          <Image img src={'https://drive.google.com/uc?export=view&id=1u1DDc4CuMIsb2monIWlTrLRnXDjTwTht'} alt="ESP" className='embedded_techimg' />
        </Carousel.Item>


      </Carousel>
    </div>


    </div>
  )
}

export default EmbeddedTechnologies
